import { FC } from "react";

import { BaseStep1EmbedLayout } from "./BaseStep1EmbedLayout";
import { BaseStep1LayoutProps } from "./BaseStep1LayoutProps";
import { BaseStep1OneColumnLayout } from "./BaseStep1OneColumnLayout";
import { BaseStep1TwoColumnLayout } from "./BaseStep1TwoColumnLayout";

export * from "./BaseStep1LayoutProps";

/**
 * This base layout handles the 1 column, 2 columns and embed layouts of all forms (V2).
 * Not meant to be used directly, but rather extended by each form.
 */
export const BaseStep1Layout: FC<BaseStep1LayoutProps> = ({ isEmbed, isOneColumn, isSquareBanner, ...rest }) => {
  if (isEmbed) {
    return <BaseStep1EmbedLayout {...rest} />;
  }

  if (isOneColumn) {
    return <BaseStep1OneColumnLayout {...rest} />;
  }

  return <BaseStep1TwoColumnLayout {...rest} isSquareBanner={isSquareBanner} />;
};
